import { render } from "./PartnerProfile.vue?vue&type=template&id=0525b49b"
import script from "./PartnerProfile.vue?vue&type=script&lang=js"
export * from "./PartnerProfile.vue?vue&type=script&lang=js"

import "./PartnerProfile.vue?vue&type=style&index=0&id=0525b49b&lang=scss"
script.render = render

export default script